import request from "../utils/requesr";

// 销售排行版
export const saleBanner = (params) => {
  return request({
    url: "/api/saleBanner",
    method: "get",
    params,
  });
};

// 售后特定平台的排名信息
export const afterSaleRank = (params) => {
  return request({
    url: "/api/afterSaleRank",
    method: "get",
    params,
  });
};

// 售前特定平台的排名信息
export const beforeSaleRank = (params) => {
  return request({
    url: "/api/saleRank",
    method: "get",
    params,
  });
};

